import { Component } from "react";

import { PaymentStatus } from "types/enum";

import { getMerchantPaymentStatusDisplayString } from "commonComponents/entity/merchantPayment/common/MerchantPaymentStatus/merchantPayments";
import { StatusDisplay, type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

interface IMerchantPaymentStatusProps {
    status: PaymentStatus;
    statusReason?: string | null;
}

class MerchantStatusDisplay {
    constructor(status: PaymentStatus) {
        this.statusText = getMerchantPaymentStatusDisplayString(status);
        switch (status) {
            case PaymentStatus.Unpaid:
                this.statusType = "";
                break;
            case PaymentStatus.Captured:
            case PaymentStatus.ManuallyCaptured:
            case PaymentStatus.PaymentCapturedButNotProperlyRecorded:
                this.statusType = "success";
                break;
            case PaymentStatus.Authorized:
            case PaymentStatus.Reserved:
            case PaymentStatus.ChargedBack:
            case PaymentStatus.Scheduled:
                this.statusType = "pending";
                break;
            case PaymentStatus.Expired:
            case PaymentStatus.Failed:
            case PaymentStatus.Cancelled:
            case PaymentStatus.Refunded:
            case PaymentStatus.RefundedAndManuallyCaptured:
            case PaymentStatus.Void:
            case PaymentStatus.Declined:
                this.statusType = "danger";
                break;
            default:
                this.statusType = "";
        }
    }

    statusText: string;
    statusType: StatusTypes;
}

export class MerchantPaymentStatusText extends Component<IMerchantPaymentStatusProps> {
    render() {
        const { status } = this.props;
        if (
            status < PaymentStatus.Unpaid ||
            status > PaymentStatus.Scheduled ||
            status === PaymentStatus.Declined
        ) {
            return "";
        }

        return new MerchantStatusDisplay(status).statusText;
    }
}

export class MerchantPaymentStatus extends Component<IMerchantPaymentStatusProps> {
    render() {
        const { status } = this.props;
        const statusDisplay = new MerchantStatusDisplay(status);
        return (
            <StatusDisplay statusType={statusDisplay.statusType}>
                {statusDisplay.statusText}
            </StatusDisplay>
        );
    }
}

export class MerchantPaymentStatusTag extends Component<IMerchantPaymentStatusProps> {
    render() {
        const { status, statusReason } = this.props;
        const statusDisplay = new MerchantStatusDisplay(status);
        if (status < PaymentStatus.Unpaid || status > PaymentStatus.Scheduled) {
            return <></>;
        } else {
            return (
                <StatusTagDisplay
                    statusText={statusDisplay.statusText}
                    statusType={statusDisplay.statusType}
                    popoverContent={statusReason}
                />
            );
        }
    }
}
